namespace JupitersChoice {
    export class FlareWipe extends PIXI.Container {

        @inject('AssetCache') _assetCache: Sapphire.AssetCache;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;

        private _data: Sapphire.DataHelper;

        private _flareSprite: PIXI.Sprite;
        private _backer: PIXI.Graphics;

        constructor(){
            super();
        }

        construct(data: any){
            this._data = new Sapphire.DataHelper(data);

            this._flareSprite = new PIXI.Sprite(this._assetCache.getTexture(this._data.get('bundle'),this._data.get('spritesheet'),this._data.get('frame')));
            this.addChild(this._flareSprite);
            this._flareSprite.pivot = new PIXI.Point(this._flareSprite.width/2,this._flareSprite.height/2);

            this._backer = new PIXI.Graphics();
            
            this._backer.beginFill(0xFFFFFF,1);
            this._backer.drawRect(0,0,1960,1960);
            this._backer.endFill();
            this._backer.pivot = new PIXI.Point(980,980);
            this._backer.x = 0;
            this._backer.y = 0;
            this.visible = false;
            this.addChild(this._backer);

            this.reset();
            this.updateLayout();
        }

        private updateLayout(){
            this.x = this._data.get('x',0);
            this.y = this._data.get('y',0);
        }

        private reset(){
            this._backer.alpha = 0;
            this._flareSprite.scale.set(0,0);
            this._flareSprite.visible = true;
        }

        setOrientation(orientation: string): void {
            this._data.orientation = orientation;
            this.updateLayout();
        }

        play(callback1?:any, callback2?:any){
            if(typeof callback1 == "undefined"){
                callback1 = () => {};
            }
            if(typeof callback2 == "undefined"){
                callback2 = () => {};
            }

            this.show();

            var duration1: number = this._data.get('showDuration',0.8);
            var duration2: number = this._data.get('hideDuration',0.5);
            TweenMax.to(this._flareSprite.scale, duration1, {
                x: 8,
                y: 8,
            });

            TweenMax.delayedCall(duration1/2,() => {
                this._backer.alpha = 0.2;
                TweenMax.to(this._backer, duration1/2, {
                    alpha: 1,
                    ease: Quart.easeOut,
                    onComplete: () => {
                        // Finally, hide layer
                        this._flareSprite.visible = false;
                        callback1();
                        TweenMax.to(this._backer, duration2, {
                            alpha:0,
                            ease: Quart.easeIn,
                            onComplete: () => {
                                callback2()
                                this.hide();
                            }
                        });
                    }
                });
            }); 
        }

        hide(){
            this.visible = false;
            this._layerManager.setVisibility('FlareWipe',false);
            this.reset();
        }

        show(){
            this.visible = true;
            this._layerManager.setVisibility('FlareWipe',true);
            this.reset();
        }
    }
}